import { ITransferTermTypesDatasource } from './../datasources/transfer_term_types_datasource';
import { IQueryMediator, IQuery } from 'core-ts-types';

export class TransferTermTypeQuery implements IQuery {
  private _result: any;
  constructor(QueryMediator: IQueryMediator, private ngTransferTermTypesDatasource: ITransferTermTypesDatasource) {
    QueryMediator.registerQuery(this, ngTransferTermTypesDatasource);
  }

  run(): TransferTermTypeQuery {
    this._result = _(this.ngTransferTermTypesDatasource.read())
      .sortBy('name')
      .value();
    return this;
  }

  get result() {
    return this._result;
  }
}

angular.module('capability-ng-transfer').service('ngTransferTermTypeQuery', TransferTermTypeQuery);



// WEBPACK FOOTER //
// ./app/lib/transfer/queries/transfer_term_type_query.ts